import type { SupportedApp } from '../types';

const ALL_APPS: SupportedApp[] = ['confluence', 'projects', 'goals', 'teams', 'focus'];

type EdgeGroup = {
	edges: string[];
};

const EDGE_GROUPS: Record<SupportedApp, EdgeGroup> = {
	confluence: {
		edges: [
			'user_favorited_confluence_page',
			'user_favorited_confluence_blogpost',
			'user_favorited_confluence_whiteboard',
			'user_favorited_confluence_database',
		],
	},
	projects: {
		edges: ['user_favorited_townsquare_project'],
	},
	goals: {
		edges: ['user_favorited_townsquare_goal'],
	},
	teams: {
		edges: ['user_favorited_team'],
	},
	focus: {
		edges: ['user_favorited_focus_area'],
	},
};

export const starredQueryBuilder = (specifiedApps: SupportedApp[]): string => {
	if (specifiedApps.length === 0) {
		return globalStarredQueryBuilder();
	}

	const sortedApps = specifiedApps.slice();
	// Sorting this list, otherwise Projects,Goals will have a different query to Goals,Projects which will mean we can't use the Relay cache.
	sortedApps.sort();

	const edges = sortedApps.flatMap((app: SupportedApp) => {
		return EDGE_GROUPS[app]?.edges ?? [];
	});

	return buildCypherQueryWithEdges(edges);
};

export const globalStarredQueryBuilder = (): string => {
	const edges = ALL_APPS.flatMap((app) => EDGE_GROUPS[app]?.edges ?? []);

	return buildCypherQueryWithEdges(edges);
};

const buildCypherQueryWithEdges = (edges: string[]): string => {
	return `MATCH (user: IdentityUser {ari: $me})-[rel:${edges.join(
		'|',
	)}]->(entity) RETURN entity, rel.createdAt ORDER BY rel.createdAt DESC`;
};
